export default __webpack_public_path__ + "static/media/snooner-icon.db7713bc.png";